'use strict';

export default class ButtonFilter {
  constructor() {

    let $filter = $('.buttons-filter--btn'),
        $selected = $('.buttons-filter--selected'),
        $title =  $('.buttons-filter--title');

    if( $(window).width() > 757 ){

        $filter.on('click', function(){
            $filter.removeClass('active');
            $(this).addClass('active');
        });
        
    }
    else{
        $filter.on('click', function() {
            var selected = $(this).text();
            var filterList = $(this).closest('ul');
            $selected.text(selected);
            filterList.removeClass('expande');
        });

        $selected.on('click', function() {
            $(this).siblings().addClass('expande');
        });

        $title.on('click', function() {
            $(this).parent().removeClass('expande');
        });
    }
    
  }
}
